type IsResponseSuccess = {
  serviceOne?: boolean;
  serviceTwo?: boolean;
};

/**
 * When both are available check both otherwise check one or the other.
 * @param serviceOne boolean
 * @param serviceTwo boolean
 * @returns boolean | undefined
 */
export const isResponseSuccess = ({
  serviceOne,
  serviceTwo,
}: IsResponseSuccess): boolean | undefined => {
  if (serviceOne !== undefined && serviceTwo !== undefined) {
    return serviceOne && serviceTwo;
  }

  return serviceTwo !== undefined ? serviceTwo : serviceOne;
};

